import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { StyledCard } from 'shared/ui/Card/StyledCard';
import { TabContext } from '@mui/lab';
import { StyledTabPanel } from 'shared/styles/StyledTabs';
import { MoreInfo } from 'shared/ui/MoreInfo/MoreInfo';
import { getHumanReadablePriorityTextByValue } from 'entities/banner/lib/utils';
import { useGetBannerByIdQuery } from 'entities/banner';

export const BannerDetailInfo = () => {
  const { id } = useParams();
  const { data: bannerDetail } = useGetBannerByIdQuery({ id });
  const [tab] = useState('1');

  return (
    <TabContext value={tab}>
      <StyledTabPanel value="1">
        <Box
          component={StyledCard}
          sx={{ marginBottom: '24px' }}
        >
          <Typography>Данные о баннере</Typography>
          <Box style={{ display: 'flex', marginTop: '12px' }}>
            <div
              className="column"
              style={{ width: '700px' }}
            >
              <MoreInfo>
                <div className="title">Фото</div>
                <img
                  style={{ width: '200px' }}
                  src={bannerDetail?.contents[0].image || ''}
                  alt="Нет фото"
                />
              </MoreInfo>
              <MoreInfo>
                <div className="title">ID</div>
                <div className="content">{bannerDetail?.id ?? '---'}</div>
              </MoreInfo>
              <MoreInfo>
                <div className="title">Наименование</div>
                <div className="content">{bannerDetail?.contents[0]?.title ?? '---'}</div>
              </MoreInfo>
              <MoreInfo>
                <div className="description">Описание</div>
                <div className="content">{bannerDetail?.contents[0]?.description ?? '---'}</div>
              </MoreInfo>
            </div>
            <div
              className="column"
              style={{ width: '700px' }}
            >
              <MoreInfo>
                <div className="function_bonus">Приоритет</div>
                <div className="content">{getHumanReadablePriorityTextByValue(bannerDetail?.priority)}</div>
              </MoreInfo>
              <MoreInfo>
                <div className="calculation_function">Статус</div>
                <div className="content">
                  {bannerDetail?.status === 1 ? 'Активен' : bannerDetail?.status === 2 ? 'Неактивен' : '---'}
                </div>
              </MoreInfo>
              <MoreInfo>
                <div className="function_value">Тип баннера</div>
                <div className="content">{bannerDetail?.app_type ?? '---'}</div>
              </MoreInfo>
            </div>
          </Box>
        </Box>
      </StyledTabPanel>
    </TabContext>
  );
};

export default BannerDetailInfo;
